// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"1f1809a6","148":"bac3f049","244":"69d488b6","285":"a7568de1","433":"9fa8c17e","478":"11502c1e","499":"be4118b9","577":"1d3e597c"}[chunkId] + ".js";
};